import Vue from "vue";
import Vuex from 'vuex';
import adminStore from './adminStore';
import userStore from './userStore';
import auth from './modules/auth';
import * as actions from './actions';

Vue.use(Vuex);

const store = {
    modules: {
        user: userStore,
        admin: adminStore,
        auth: auth
    },
    state: {
        menuId: null,
        menuData: [],
        appName: "Booking System",
        baseDataUrl: "https://sneos-app.firebaseio.com",
        showCreateAdminLink: false,
        isAdmin: false,
        showNavRow: false,
        showLeftSideMenu: false

    },
    getters: {
        menuUrl: (state) => {
            if (state.menuId) {
                console.log('menuid is', state.menuId);
                let url = state.baseDataUrl + "/menus/{$menu}.json";
                console.log('menuid', state);
                return url.replace("{$menu}", state.menuId);
            }
            return null;
        }
    },
    mutations: {
        SET_MENU(state, menu) {
            console.log('set_menu:', menu);
            state.menuData = menu;
        },
        LEFT_SIDE_MENU_VISIBLE(state, isVisible) {
            state.showLeftSideMenu = isVisible;
        },
        NAV_ROW_VISIBLE(state, isVisible) {
            state.showNavRow = isVisible;
        },
    },
    actions
};

const storeForBookingApp = new Vuex.Store(store);

export default storeForBookingApp